'use strict';

/** Import frontoffice_app */
import '../frontoffice_app';

/** Import AjaxHandler class */
import AjaxHandler from '../../../shared/utility/ajax_handler/ajax_handler'

/**
 * @class LowestPriceHandler
 */
class LowestPriceHandler
{
    /**
     * @constructor
     */
    constructor ()
    {
        this._listenSendQuestion();
    }

    /**
     * @private
     */
    _listenSendQuestion ()
    {
        let button = $('#submit-info-mail');
        button.on('click', (e) =>
        {
            e.preventDefault();
            button.attr("disabled", true);

            let
                modal = $('#infoMailModal'),
                mailData = {
                    sender: $('#name').val(),
                    mail: $('#email').val(),
                    title: $('#subject').val(),
                    message: $('#message').val(),
                };

            AjaxHandler.post('question', mailData).then((response) =>
            {
                if (response.success)
                {
                    $('#name').val(null);
                    $('#email').val(null);
                    $('#subject').val(null);
                    $('#message').val(null);

                    let html = '<div class="modal-header"><h5 class="modal-title" id="exampleModalLabel">Email poslat</h5></div>' +
                        '<div class="modal-body"><p>Vaše pitanje je uspešno poslato.</p></div>' +
                        '<div class="modal-footer"><button id="infoModalClose" type="button" class="btn btn-primary" data-dismiss="modal">Zatvori</button></div>';

                    modal.find('.modal-content').html(html);
                    modal.modal();
                }
                button.attr("disabled", false);
            })
        })
    }
}

/** Start ProductSingleHandler */
$(document).ready(() => { new LowestPriceHandler(); });


// WEBPACK FOOTER //
// ./assets/js/components/frontoffice/pages/lowest_price.js